"use strict";
module.exports = {
    entityModel: 'failedActionCall',
    events: {
        FAILED_ACTION_CALL_CREATED: 'FAILED_ACTION_CALL_CREATED',
        FAILED_ACTION_CALL_UPDATED: 'FAILED_ACTION_CALL_UPDATED',
        FAILED_ACTION_CALL_RESENT: 'FAILED_ACTION_CALL_RESENT',
    },
    actions: {
        get: 'v1.failedActionCall.get',
        list: 'v1.failedActionCall.list',
        writeFailedActionCall: 'v1.failedActionCall.writeFailedActionCall',
        retry: 'v1.failedActionCall.retry',
        markAsObsolete: 'v1.failedActionCall.markAsObsolete',
        upsert: 'v1.failedActionCall.upsert',
        upsertWhenEmpty: 'v1.failedActionCall.upsertWhenEmpty',
        updateWhenEmpty: 'v1.failedActionCall.updateWhenEmpty',
        update: 'v1.failedActionCall.update',
    },
    statuses: {
        error: 'error',
        resolved: 'resolved',
        obsolete: 'obsolete',
    },
};
